export const CRMIcon = ({ useOriginalColor }) => (
  <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0976 1.60306C19.8452 2.01587 20.1166 2.95656 19.7038 3.70416L14.3533 13.3939C13.9455 14.1324 13.021 14.4078 12.2756 14.0127L7.08796 11.2634L3.28166 16.6718C2.79016 17.3702 1.82557 17.5379 1.12719 17.0464C0.428807 16.5549 0.261094 15.5904 0.752592 14.892L5.34328 8.36894C5.79157 7.73196 6.64368 7.52785 7.33191 7.8926L12.3808 10.5684L16.9965 2.20925C17.4093 1.46166 18.35 1.19026 19.0976 1.60306Z"
      fill={useOriginalColor ? "url(#paint0_linear_1645:72876)" : "currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1602 0.892986C19.5376 1.07353 19.8251 1.39972 19.9568 1.79693L21.8058 7.37185C22.0743 8.18154 21.6348 9.0579 20.8241 9.32924C20.0134 9.60058 19.1385 9.16416 18.8699 8.35446L17.5235 4.29473L13.1745 5.91106C12.3731 6.20892 11.4841 5.8016 11.189 5.00128C10.8939 4.20096 11.3044 3.31071 12.1058 3.01285L17.9546 0.839128C18.3477 0.693009 18.7828 0.712445 19.1602 0.892986Z"
      fill={useOriginalColor ? "url(#paint1_linear_1645:72876)" : "currentColor"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_1645:72876"
        x1="9.9881"
        y1="3.22274"
        x2="10.3792"
        y2="15.5159"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B695" />
        <stop offset="1" stopColor="#00E2BA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1645:72876"
        x1="16.5544"
        y1="2.26257"
        x2="16.4807"
        y2="7.81198"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B695" />
        <stop offset="1" stopColor="#00E2BA" />
      </linearGradient>
    </defs>
  </svg>
);
